import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";
import { Blog } from '../../types/types';
export type AddBlogDTO = Blog & {
    instructorId:string;
}

type AddBlogResponse  = AddBlogDTO & ApiError;

export const AddNewBlog = (data: AddBlogDTO): Promise<AddBlogResponse> => {
    return axios.post("/blog/create", data)
        .then(response => response.data as AddBlogResponse);
};